import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CreditCardValidators } from 'angular-cc-library';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { APP_CONSTANT, AppConst } from 'src/app/core/_constants/app.constant';
import { MainService } from 'src/app/core/_services/main.service';
import { ValidationService } from 'src/app/core/_services/validation.service';
import { ChequePaymentComponent } from '../cheque-payment/cheque-payment.component';
import { LocalStorageProvider } from 'src/app/core/_services/storage.service';

declare var Runner: any;

export function fiveWordsValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value || '';
    const wordCount = value.trim();
    return wordCount.length > 5 ? null : { fiveWords: true };
  };
}
export function validateExpDateMMYY(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  // Match MM/YY format strictly
  const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
  if (!regex.test(value)) {
    return { invalidFormat: true };
  }

  const [monthStr, yearStr] = value.split('/');
  const month = parseInt(monthStr, 10);
  const year = parseInt('20' + yearStr, 10); // Convert YY to YYYY

  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const currentYear = now.getFullYear();

  if (year < currentYear || (year === currentYear && month < currentMonth)) {
    return { expired: true };
  }

  return null; // valid
}

@Component({
  selector: 'app-online-payment',
  templateUrl: './online-payment.component.html',
  styleUrls: ['./online-payment.component.scss']
})
export class OnlinePaymentComponent implements OnInit {

  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxLength = AppConst.MAXLENGTH;
  public creditCardForm: FormGroup;
  public bankAccountForm: FormGroup;
  submitted: boolean = false;
  paymentOnline: any = 'credit';
  userProfile: any;

  constructor(public dialogRef: MatDialogRef<OnlinePaymentComponent>, private storageService: LocalStorageProvider, @Inject(MAT_DIALOG_DATA) public data: any, private service: MainService, private fb: FormBuilder, private loader: NgxUiLoaderService, private toastr: ToastrService, private router: Router, public validationService: ValidationService) {
    this.userProfile = this.storageService.getItem('CurrentUser');
  }


  runPay: boolean = false;
  ngOnInit(): void {
    this.creditCardForm = this.createForm();
    this.bankAccountForm = this.createBankForm();
    this.creditCardForm.patchValue({
      email: this.data?.details?.operDetails?.customer_data?.email
    })

    if (this.userProfile?.activePaymentGateway === 'RUNPAYMENTS') {
      this.runPay = true;
      this.creditCardForm.get('cardNumber').clearValidators();
      this.creditCardForm.get('cardCode').clearValidators();
      this.creditCardForm.updateValueAndValidity();
    }
  }

  isCCSeleceted: boolean = false;
  optionChanged() {
    this.isCCSeleceted = true;
    this.creditCardForm.reset();
    this.bankAccountForm.reset();
  }

  createBankForm() {
    return this.fb.group({
      accountType: ['', Validators.required], // checking,savings, businessChecking
      routingNumber: ['', [Validators.required, Validators.pattern('^\s*-?[0-9]{1,9}\s*$')]], //Numeric string, up to 9 digits.
      accountNumber: ['', [Validators.required, Validators.pattern('^\s*-?[0-9]{1,17}\s*$')]], //Numeric string, up to 17 digits.
      nameOnAccount: ['', [Validators.required, Validators.maxLength(22)]] // String, up to 22 characters
    })
  }

  createForm() {
    return this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      holderName: ['', [Validators.required, fiveWordsValidator()]],
      cardNumber: ['', [Validators.required, CreditCardValidators.validateCCNumber]],
      expirationDate: ['', [Validators.required, CreditCardValidators.validateExpDate]],
      cardCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
    })
  }

  get f() { return this.creditCardForm.controls; }
  get g() { return this.bankAccountForm.controls; }


  close(value: Boolean) {
    this.dialogRef.close(value);
  }

  chargeSubmit() {
    this.submitted = true;
    if (this.paymentOnline == 'credit' && this.creditCardForm.valid) {
      let expDate = this.creditCardForm.value.expirationDate.split('/');
      const [month, year] = expDate;
      const formattedDate = `${month.trim()}${year.trim()}`;
      const data = {
        card_holder_name: this.creditCardForm.value.holderName,
        email: this.creditCardForm.value.email,
        paymentType: "CREDITCARD",
        receiverId: this.data?.details?.operDetails?.emp_data?.length ? this.data?.details?.operDetails?.emp_data[0]._id : '',
        senderId: this.data?.details?.operDetails?.customerId,
        amount: Number(this.data?.total) || 0,
        creditCardNumber: this.creditCardForm.value.cardNumber.split(" ").join(''),
        expirationDate: formattedDate,
        cardCode: this.creditCardForm.value.cardCode,
        opportunityId: this.data?.details?.oppId || '',
        method: this.data?.method,
        notes: this.data?.notes,
        tip: Number(this.data?.tip) || 0,
        opportunityAmount: this.data.details?.operDetails?.totalAmount
      }
      if (this.runPay) {
        data['account_token'] = this.accountToken;
      }
      this.pay(data);
    }
    else if (this.paymentOnline == 'bank' && this.bankAccountForm.valid) {
      const data = {
        paymentType: "BANKACCOUNT",
        receiverId: this.data?.details?.operDetails?.emp_data.length ? this.data?.details?.operDetails?.emp_data[0]._id : '',
        senderId: this.data?.details?.operDetails?.customerId,
        amount: this.data?.total || 0,
        bankAccount: {
          ...this.bankAccountForm.value,
        },
        opportunityId: this.data?.details?.oppId,
        method: 'online',
        notes: this.data?.notes,
        opportunityAmount: this.data?.details?.operDetails?.totalAmount
      }
      this.pay(data);
    }
  }

  pay(data) {
    if (this.data.sendData) {
      this.dialogRef.close(data)
    }
    else {
      this.loader.start();
      this.service.post2(data, `${API_ROUTES.PAYMENT.checkout}`).pipe().subscribe(
        {
          next: (response: any) => {
            this.loader.stop();
            if (response.status) {
              this.toastr.success(response.msg);
              this.dialogRef.close(true);
            } else {
              this.toastr.error(response.msg)
            }
          },
          error: (err: any) => {
            this.loader.stop();
            this.toastr.error(err.msg)
          }
        }
      );
    }
  }

  runner: any;
  accountToken: string = '';
  expiryFromRunner: string = '';
  private isTokenizing = false;
  private tokenizeTimeout: any;

  ngAfterViewInit(): void {
    if (this.userProfile?.activePaymentGateway === 'RUNPAYMENTS') {
      this.loader.start();
      setTimeout(() => {
        this.runner = new Runner();
        this.runner.init({
          element: "#run-form",
          publicKey: this.userProfile?.runPaymentsObj?.auth?.publicKey,
          cardLabel: 'Card Number',
          cvvLabel: 'CVV',
          useCvv: true,
          useExpiry: true,
          cvvFieldSelector: "#cvvId",
          cardNumberFieldSelector: "#cardNumber-container",
          cardPlaceholder: 'Enter Card Number #',
          cvvPlaceholder: 'Enter CVV #',
          css: `
                * {
                  box-sizing: border-box;
                  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                }

                #cccardlabel, #cccvvlabel, #ccexpirylabel {
                  font-size: 13px !important;
                  font-family: sans-serif;
                  font-weight: 600 !important;
                  color: #444444;
                  margin-bottom: 6px !important;
                  text-transform: uppercase;
                  letter-spacing: 0.04em;
                }

                input {
                  border: none;
                  border-bottom: 1.5px solid #d1d5db;
                  border-radius: 0;
                  font-family: sans-serif;
                  font-weight: 500;
                  font-size: 15px;
                  color: #1d1d1e;
                  padding: 10px 0;
                  width: stretch;
                  background: transparent;
                  margin: 4px 0 16px 0;
                  letter-spacing: 0.12em;
                }

                input::placeholder {
                  color: #c0c0c0;
                  letter-spacing: 0.06em;
                }

                input:focus {
                  outline: none !important;
                  border-bottom-color: #7c3aed;
                }

                select {
                      border: 1px solid #ced4da;
                      border-radius: 10px;
                      font-family: sans-serif;
                      font-weight: 500;
                      font-size: 14px;
                      color: #6b7280;
                      padding: 10px 14px;
                      margin: 4px 0 16px 0;
                      background-color: #fff;
                      appearance: auto;
                      cursor: pointer;
                      min-width: 90px;
                  }

                select:focus {
                  outline: none !important;
                  border-color: #7c3aed;
                }

                iframe {
                  width: strech !important;
                  min-height: 250px !important;
                }
              `
        });

        this.loader.stop();
        // Capture token automatically as user fills in card details
        this.runner.onTokenize((res: any) => {
          console.log('Auto tokenized:', res);
          this.isTokenizing = false;

          if (res.hasToken) {
            this.accountToken = res.token;
            const expiry = res.expiration || '';

            if (expiry.length >= 5) {
              const year = expiry.slice(0, 4);
              const month = expiry.slice(4);

              const formattedMonth = month.padStart(2, '0');
              const formattedYear = year.slice(-2);

              this.expiryFromRunner = `${formattedMonth}/${formattedYear}`;
              this.creditCardForm.patchValue({
                expirationDate: this.expiryFromRunner
              })
            } else {
              this.expiryFromRunner = '';
            }
          } else {
            this.accountToken = null; // Reset if tokenization failed
          }
        });

      }, 0);
    }
  }
  check(): void {
    if (this.accountToken) {
      return;
    }

    // Token not yet available — wait briefly for async tokenization to complete
    this.isTokenizing = true;
    clearTimeout(this.tokenizeTimeout);

    this.tokenizeTimeout = setTimeout(() => {
      this.isTokenizing = false;

      if (!this.accountToken) {
        this.toastr.info('Please enter correct card details to proceed.');
      }
    }, 1500); // Wait 1.5s for onTokenize to fire
  }
}
